import { Col, Row } from "reactstrap";
import SelectableCard from "../CreateCloudComponents/SelectableCard";

// Selectable card group for selecting a cloud Tier.
const TierGroup = ({ values, onChange }) => {
  return (
    <Row className="align-items-center">
      <Col xs="12" sm="6" className="mb-3 mb-sm-0 pr-1">
        <SelectableCard
          title="Team"
          description="Affordable instances designed for small and medium-sized growing organizations"
          icon={
            <i className="mdi mdi-account-group" style={{ fontSize: 48 }} />
          }
          isSelected={values.Tier === "Team"}
          onClick={() => onChange({ target: { name: "Tier", value: "Team" } })}
        />
      </Col>
      <Col xs="12" sm="6" className="pl-1">
        <SelectableCard
          title="Enterprise"
          description="Custom-tailored instances designed for large enterprise organizations"
          icon={<i className="mdi mdi-domain" style={{ fontSize: 48 }} />}
          isSelected={values.Tier === "Enterprise"}
          onClick={() =>
            onChange({ target: { name: "Tier", value: "Enterprise" } })
          }
          disabled={true}
        />
      </Col>
    </Row>
  );
};

export default TierGroup;
